import { pathgen } from 'object-path-generator';
import { Box, CloseButton, Typography } from 'seagull';
import pluralize from "../../../../utils/pluralize";
import { BulkInvoiceDetails } from "./BulkInvoiceDetails/BulkInvoiceDetails";
import styles from "./FileDetails.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getItemsCount = (lines, invoicesCount) => {
  return "".concat(lines, " line ").concat(pluralize('item', lines), " in ").concat(invoicesCount, " ").concat(pluralize('invoice', invoicesCount));
};
export const FileDetailsTestIds = pathgen('FileDetailsTestIds');
export const FileDetails = _ref => {
  let {
    name,
    lines,
    invoicesCount,
    invoices,
    onRemove
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    className: styles.fileDetailsWrapper,
    children: [/*#__PURE__*/_jsxs(Box, {
      className: styles.fileDetails,
      "data-testid": FileDetailsTestIds.Container(),
      children: [/*#__PURE__*/_jsxs(Box, {
        className: styles.fileDetailsText,
        children: [/*#__PURE__*/_jsx(Typography, {
          "data-testid": FileDetailsTestIds.Name(),
          children: name
        }), lines && invoicesCount && /*#__PURE__*/_jsxs(Typography, {
          "data-testid": FileDetailsTestIds.FileSummaryInfo(),
          skin: "secondary",
          children: ["(", getItemsCount(lines, invoicesCount), ")"]
        })]
      }), /*#__PURE__*/_jsx(CloseButton, {
        size: "small",
        onClick: onRemove,
        "data-testid": FileDetailsTestIds.RemoveFileButton()
      })]
    }), /*#__PURE__*/_jsx(BulkInvoiceDetails, {
      invoices: invoices !== null && invoices !== void 0 ? invoices : []
    })]
  });
};